<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>短途运输杂费合计说明:<br>
					<span>1、首页通过弹出编辑窗口构建筛选时间段和筛选对象，然后再开始筛选。</span><br>
					<span class="red">2、当存在筛选出来的相应合计数据时，对应的短途运输内容不允许编辑!!!。</span><br>
					<span class="red">3、当杂费合计提交时，可在工资计算步骤匹配。同样一旦</span><br>
					<span>4、查询关键字:单号、车牌、开始日期、截至日期、装货点、客户姓名、司机、状态。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button class="pre_btn_ok" @click="edit_mode()">杂费合计确认</button>
			</template>
			<template slot="pre_tan_button">
				<button class="pre_btn_ok" @click="edit_mode()">杂费合计确认</button>
			</template>
		</pre-base>
		<cardsum ref="cardsum"></cardsum>
	</div>
</template>

<script>
	import {
		GetShort
	} from '@/utils/localstore.js';

	import api from '@/utils/type.js';
	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_v2.vue"),
			'cardsum': () => import("./tan_car_dsum.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "trans_other",
					"title": "短途运输杂费合计",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"isShowEdit": "1",
					"step": "0",
					"sel_action": 'exp_dtys_trans_dsum_mlist',
					"upd_action": 'exp15_dtys_trans_dsum_m',
					"detail_part": "1",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": 'exp_dtys_trans_dsum_d',
					"d_upd_action": '_dtys_trans_dsum_d',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "司机",
							"val": "",
							"key": "dri_name",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "截至日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "5"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "司机",
							"val": "",
							"key": "driver",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": '1',
							"w": '0'
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "text",
							"class": "long1 ",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "截至日期",
							"val": "",
							"key": "e_date",
							"type": "text",
							"class": "long1 ",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "趟数",
							"val": "",
							"key": "dri_num",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "工资",
							"val": "",
							"key": "dri_amount",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "备用金分配",
							"val": "",
							"key": "xj_start",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "备用金消耗",
							"val": "",
							"key": "xj_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "现金加气",
							"val": "",
							"key": "gas_xj",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "现金ETC",
							"val": "",
							"key": "etc_xj",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "过路费",
							"val": "",
							"key": "glf_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},

						{
							"name": "维修",
							"val": "",
							"key": "wh_pay_xj",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						{
							"name": "停车费",
							"val": "",
							"key": "tcf_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},

						{
							"name": "罚款",
							"val": "",
							"key": "fk_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						{
							"name": "加水",
							"val": "",
							"key": "jia_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						{
							"name": "其他费用",
							"val": "",
							"key": "qt_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						{
							"name": "备用金抵扣",
							"val": "",
							"key": "xj_end",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "车牌"
						},
						{
							"name": "司机"
						},
						{
							"name": "状态"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "截至日期"
						},
						{
							"name": "趟数"
						},
						{
							"name": "收入"
						},
						{
							"name": "备用金分配"
						},
						{
							"name": "备用金消费"
						},
						{
							"name": "现金加气"
						},
						{
							"name": "现金ETC"
						},
						{
							"name": "过路费"
						},
						{
							"name": "维修"
						},
						{
							"name": "停车费"
						},
						{
							"name": "罚款"
						},
						{
							"name": "加水"
						},
						{
							"name": "其他"
						},

						{
							"name": "备用金抵扣"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						// {
						// 	"name": "浏览地址"
						// },
						// {
						// 	"name": "存储地址"
						// },
						{
							"name": "修改时间"
						}
					],
					"d_parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "车牌"
						},
						{
							"name": "司机"
						},
						{
							"name": "装箱日期"
						},
						{
							"name": "工资"
						},
						{
							"name": "备用金分配"
						},
						{
							"name": "备用金消费"
						},
						{
							"name": "现金加气"
						},
						{
							"name": "现金ETC"
						},
						{
							"name": "过路费"
						},
						{
							"name": "维修"
						},
						{
							"name": "停车费"
						},
						{
							"name": "罚款"
						},
						{
							"name": "加水"
						},
						{
							"name": "其他"
						},

						{
							"name": "备用金抵扣"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						// {
						// 	"name": "浏览地址"
						// },
						// {
						// 	"name": "存储地址"
						// },
						{
							"name": "修改时间"
						}
					]

				});


			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: function(type) {
				let that = this;
				this.$nextTick(function() {
					that.$refs['cardsum'].showpop();
				});

			}







		}
	};
</script>
<style>
</style>